<wilson-users-select
  [label]="('general.users' | translate) + '*'"
  [(ngModel)]="userId"
  (ngModelChange)="onUserIdChange($event)"
  name="userId"
></wilson-users-select>
